export enum LogInTargetHttpPaths {
  lastLoggedIn = '/api/v1.0/staff/login-date',
}
